<div class="wrapper">
  <div class="cooking-story-header" [ngClass]="{ active: shadowNav }">
    <div class="header">
      <img
        src="assets/cookingbook/angle-white.svg"
        (click)="goBack()"
        class="goback icon-shadow"
        alt=""
      />
      <p class="title">{{ activeTabTitle }}</p>
      <div class="dividar"></div>
      <div
        *ngIf="activeTab == 0 && isReady"
        class="selectAll"
        [ngClass]="{ active: isGerocerySelectdAll }"
        (click)="toggleAllShoppingList()"
      >
        انتخاب همه
      </div>
      <div
        *ngIf="activeTab == 1 && isReady"
        class="selectAll"
        [ngClass]="{ active: isKitchenSelectdAll }"
        (click)="toggleAllKitchenList()"
      >
        انتخاب همه
      </div>
      <div class="icon-shadow center icon" *ngIf="activeTab == 0 && isReady">
        <img
          *ngIf="isReady"
          (click)="share()"
          src="assets/cookingbook/share.svg"
          alt=""
        />
      </div>

      <div class="icon" *ngIf="!isReady">
        <ngx-skeleton-loader
          animation="pulse"
          class="icon"
          [theme]="{
            width: '32px',
            height: '32px',
            'border-radius': '12px',
            'backgrund-color': '#eceef0'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <div class="tabs">
      <div class="tab" (click)="changeTab(1)">لیست خرید</div>
      <div class="tab" (click)="changeTab(0)">آشپزخانه</div>
      <div
        id="tab"
        [ngStyle]="{ left: activeTab == 1 ? '4px' : 'calc(50% - 4px)' }"
      >
        {{ activeTabTitle }}
      </div>
    </div>
  </div>
  <div
    class="cooking-story-body"
    #scroolEl
    (scroll)="scrolling($event)"
    *ngIf="home"
  >
    <ngx-skeleton-loader
      animation="pulse"
      *ngIf="!isReady"
      [theme]="{
        'backgrund-color': '#eceef0',
        padding: '0 24px',
        margin: '0 24px',
        display: 'flex',
        height: '56px',
        'margin-top': '24px',
        'border-radius': '24px',
        'align-items': 'center',
        width: 'unset'
      }"
    ></ngx-skeleton-loader>
    <div
      (click)="openMembers()"
      *ngIf="home.members.length + 1 >= 2 && isReady"
      class="members"
    >
      <p>این لیست با افراد خانه مشترک است</p>
      <div class="divider"></div>
      <div>{{ home.members.length + 1 }} نفر</div>
      <img src="assets/cookingbook/angle-right-white.svg" alt="" />
    </div>
    <div
      class="page"
      [ngStyle]="{ display: activeTab == 1 ? 'block' : 'none' }"
    >
      <app-kitchen></app-kitchen>
    </div>
    <div
      class="page"
      [ngStyle]="{ display: activeTab != 1 ? 'block' : 'none' }"
    >
      <app-shoppinglist></app-shoppinglist>
    </div>
  </div>
</div>
<app-cooking-story-tutorial-kitchen
  [type]="type"
  *ngIf="showTutorial"
></app-cooking-story-tutorial-kitchen>
<app-cooking-story-success-message></app-cooking-story-success-message>
